<template>
  <div v-if="!currentUserRegInitialized">
    --user registration here--
    <p><EnterUserRegistration /></p>
    --user registration here--
    <!-- <p>{{ currentUserRegInitialized }}</p> -->
  </div>
  <div v-else>
    User has been registered... go to other functionality here
    <p>{{ currentUserRegInitialized }}</p>
  </div>
</template>

<script>
import EnterUserRegistration from "@/components/EnterUserRegistration.vue";

export default {
  name: "functionalityHead",
  components: {
    EnterUserRegistration
  },
  computed: {
    //the following shows how to use store getters
    currentUserRegInitialized() {
      return !!this.$store.getters.getCurrentUserRegInitialized;
    }
  }
};
</script>
